import React, { useContext } from "react";
import { Link } from "react-router-dom";

// External components
import SVG from "react-inlinesvg";

// Contexts
import { DataContext } from "~/contexts/Data";

const JubileumsLogoHeader = () => {
  return (
    <img src="/header.svg"/>
  );
};
const JubileumsLogoFooter = () => {
  return (
    <img src="/footer.svg"/>
  );
};
function isYear2026(date) {
  if (date.getFullYear() === 2026) {
    return true;
  } else {
    return false;
  }
}
const Logo = ({ style, className, footer = false, onClick }) => {
  const { umbData } = useContext(DataContext);

  let is2026 = isYear2026(new Date());

  if (footer && umbData.footerLogo?.url) {
    return (
      <Link to="/" className={className} onClick={onClick}>
        <span className={`logo `}>
          {is2026 ? (
            <JubileumsLogoFooter />
          ) : (
            <SVG src={umbData.footerLogo?.url} style={{ style }} />
          )}
        </span>
      </Link>
    );
  } else if (umbData.headerLogo?.url) {
    return (
      <Link to="/" className={className} onClick={onClick}>
        <span className={`logo `}>
          {is2026 ? (
            <JubileumsLogoHeader />
          ) : (
            <SVG src={umbData.headerLogo?.url} style={{ style }} />
          )}
        </span>
      </Link>
    );
  } else return null;
};

export default Logo;
